import { render, staticRenderFns } from "./secondMenu.vue?vue&type=template&id=ab744394&scoped=true&"
import script from "./secondMenu.vue?vue&type=script&lang=js&"
export * from "./secondMenu.vue?vue&type=script&lang=js&"
import style0 from "./secondMenu.vue?vue&type=style&index=0&id=ab744394&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab744394",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ab744394')) {
      api.createRecord('ab744394', component.options)
    } else {
      api.reload('ab744394', component.options)
    }
    module.hot.accept("./secondMenu.vue?vue&type=template&id=ab744394&scoped=true&", function () {
      api.rerender('ab744394', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/components/pageLayout/secondMenu.vue"
export default component.exports